export default __webpack_public_path__ + "static/media/our-team-9.be5c2141.jpg";